(function () {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const checkoutUrl = root.endsWith('/') ? `${root}checkout` : `${root}/checkout`;
  const cartAddUrl = `${root.replace(/\/?$/, '')}/cart/add.js`;

  function isPpaCheckoutForm(form) {
    return form instanceof HTMLFormElement && form.classList.contains('pss-ppa-checkout-form');
  }

  function redirectToCheckout() {
    window.location.assign(checkoutUrl);
  }

  function handlePpaCheckout(form, submitter) {
    const formData = new FormData(form);
    formData.delete('return_to');

    if (submitter) {
      submitter.setAttribute('aria-disabled', 'true');
      submitter.disabled = true;
    }

    return fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((payload) => {
        if (payload.status) {
          throw new Error(payload.description || payload.message || 'Unable to add to cart');
        }
        redirectToCheckout();
      })
      .catch((error) => {
        if (submitter) {
          submitter.removeAttribute('aria-disabled');
          submitter.disabled = false;
        }
        throw error;
      });
  }

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!isPpaCheckoutForm(form) || form.closest('product-form')) return;

      event.preventDefault();
      event.stopPropagation();

      handlePpaCheckout(form, event.submitter).catch((error) => {
        window.alert(error.message || 'Something went wrong. Please try again.');
      });
    },
    true
  );

  window.PssPpaCheckout = { handlePpaCheckout, redirectToCheckout, isPpaCheckoutForm };
})();
